<script lang="ts">
  import { Avatar } from '@shared/ui/avatar';
  import { Icon } from '@shared/ui/icon';
  import { is } from '@shared/lib/utils';
  import { useWallet } from '@do/svelte-web3-manager';

  export let label: string;
  export let onDelete: (() => void) | undefined = undefined;
  export let href: string | undefined = undefined;

  export let variant: 'primary' | 'secondary' = 'primary';
  export let size: 'sm' | 'md' | 'lg' = 'sm';

  const wallet = useWallet();

  const styles = {
    sizes: {
      sm: 'text-sm px-2 py-1.5 gap-1',
      md: 'text-base px-2 py-2 gap-1',
      lg: 'text-lg px-2 py-2',
    },
    variant: {
      primary: '',
      secondary: 'rounded-full',
    },
  };
</script>

<svelte:element
  this="{href ? 'a' : 'div'}"
  {href}
  class="
    bg-default-100 text-default-900 dark:bg-dark-100 flex items-center font-medium transition-colors dark:text-white
    {is(!!href, 'hover:bg-default-900 dark:hover:bg-dark-900 dark:hover:text-dark-50 cursor-pointer hover:text-white')}
    {styles.sizes[size]}
    {styles.variant[variant]}
  "
>
  <Avatar wallet="{$wallet?.address || '0x527eE0c30369466c8A8a1C98770919d65439c1c6'}" />

  <p class="px-1">{label}</p>

  {#if onDelete}
    <button class="h-full pl-0.5" type="button" on:click|stopPropagation="{onDelete}">
      <Icon name="close" classes="fill-default-600 hover:fill-default-900 dark:fill-dark-700 dark:hover:fill-white" />
    </button>
  {/if}
</svelte:element>
